import rootReducer from './index';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagaindex';

const sagaMidelware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMidelware));
sagaMidelware.run(rootSaga);

export default store;
